import styled from "styled-components";

export const SidebarBox = styled.section`
  font-size: 87.5%;
  padding-top: 1rem;
  margin-top: -1px;
  border-top: 1px solid ${(p): string => p.theme.gray300};
  border-bottom: 1px solid ${(p): string => p.theme.gray300};
`;
